// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { SupportStateType } from '../../../types/Model';

export interface UpdateSupportStatusRequestPayload {
  id: number;
}

export interface UpdateSupportStatusSuccessPayload {
  supportStatus: SupportStateType;
}

export interface UpdateSupportStatusFailPayload {
  error: Error;
}

const updateSupportStatusActions = createAsyncAction(
  'elearning/UPDATE_STATUS_SUPPORT_DATA',
  'elearning/UPDATE_STATUS_SUPPORT_DATA_SUCCESS',
  'elearning/UPDATE_STATUS_SUPPORT_DATA_FAIL'
)<
  UpdateSupportStatusRequestPayload,
  UpdateSupportStatusSuccessPayload,
  UpdateSupportStatusFailPayload
>();

export { updateSupportStatusActions as default }
